import { useEffect, useRef } from "react";
import { useIsMobile } from "../../functions/deviceIdentity/getDeviceType";

const MessageModal = (props) => {

    const { modalOpen, onClose, MessageText} = props;
    const ref = useRef();
    const isMobile = useIsMobile();

    const handleClose = () => {
        onClose();
        ref.current?.close();
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                handleClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        if (modalOpen) {
            ref.current?.showModal();
        } else {
            ref.current?.close();
        }

    }, [modalOpen]);



    return (
        <dialog className="gt-modal" aria-labelledby="deleteTodo" ref={ref}>
            <div className="gt-modal-content">
                <div className="gt-modal-content__heading">
                    <h2 id="smartAssistant">Information</h2>
                    <button className="gw-icon-button gw-icon-button--icon" aria-label="close delete modal"
                        onClick={() => { handleClose() }}
                    >
                        <i className="gw-icon-button__icon gw-button__icon--close"></i>
                    </button>
                </div>
                <div className="gt-modal-content__body" style={{fontSize: '24'} }>
                    <p>{MessageText}</p>
                </div>
                {/*<div style={{ display: "flex", justifyContent: "right", padding: '1.5em' }}>*/}
                    
                {/*    <button className="gw-button gw-button--secondary"*/}
                {/*        onClick={() => { handleClose() }}*/}
                {/*        style={{ marginRight: '0.5em' }}*/}
                {/*    >Cancel</button>*/}
                   
                {/*    <button className="gw-button gt-button-field--secondary" style={{ backgroundColor: '#D4262A', color: '#fff'}}*/}
                {/*        onClick={() => { handleDeleteTask() }} */}
                {/*    >Delete</button>*/}
                {/*</div>*/}
            </div>
        </dialog>
    );
}

export default MessageModal;